import {
  PSMS_DIGITAL_SOLUTION_SUMMARY_REQUEST,
  PSMS_DIGITAL_SOLUTION_SUMMARY_LOADING,
  PSMS_DIGITAL_SOLUTION_SUMMARY_SUCCESS,
  PSMS_DS_ADOPTIONRATE_LOADING,
  PSMS_DS_ADOPTIONRATE_REQUEST,
  PSMS_DS_ADOPTIONRATE_SUCCESS,
} from '../actionTypes';

export const getPSMSDigitalSummary = <TPayload>(payload: TPayload) => ({
  type: PSMS_DIGITAL_SOLUTION_SUMMARY_REQUEST,
  payload,
});

export const getPSMSDigitalLoading = (payload: boolean) => ({
  type: PSMS_DIGITAL_SOLUTION_SUMMARY_LOADING,
  payload,
});

export const getPSMSDigitalDataSuccess = <TPayload>(payload: TPayload) => ({
  type: PSMS_DIGITAL_SOLUTION_SUMMARY_SUCCESS,
  payload,
});

export const getPSMSDigitalSummaryAdoptionRate = <TPayload>(payload: TPayload) => ({
  type: PSMS_DS_ADOPTIONRATE_REQUEST,
  payload,
});

export const getPSMSDigitalAdoptionRateLoading = (payload: boolean) => ({
  type: PSMS_DS_ADOPTIONRATE_LOADING,
  payload,
});

export const getPSMSDigitalAdoptionRateSuccess = <TPayload>(payload: TPayload) => ({
  type: PSMS_DS_ADOPTIONRATE_SUCCESS,
  payload,
});
